import { createSelector } from 'reselect';
import get from 'lodash/get';

export function makeSelectorFactory(rootState) {
  return function getSelectors(innerKey) {
    const selectState = createSelector(
      rootState,
      state => get(state, innerKey, {}),
    );
    const selectStatePending = createSelector(
      selectState,
      state => get(state, 'sending', false),
    );
    const selectStateError = createSelector(
      selectState,
      state => get(state, 'error', null),
    );
    const selectStateSucceed = createSelector(
      selectState,
      state => get(state, 'succeed', false),
    );
    const selectStateRejected = createSelector(
      selectState,
      state => get(state, 'rejected', false),
    );
    const selectStateList = createSelector(
      selectState,
      state => get(state, 'list', []),
    );

    const selectStateData = createSelector(
      selectState,
      state => get(state, 'data', null),
    );

    const makeSelect = (key, defaultValue) =>
      createSelector(
        selectState,
        state => get(state, key, defaultValue),
      );

    return {
      selectState,
      selectStatePending,
      selectStateRejected,
      selectStateError,
      selectStateSucceed,
      selectStateList,
      selectStateData,
      makeSelect,
    };
  };
}



// WEBPACK FOOTER //
// ./src/utils/redux/selectAdapter.js